export const landSizes = {
  "Hacienda Vista Juriquilla": [
    "de 250 a 750 m²",
    "de 750 a 1,000 m²",
    "Más de 1,000 m²",
  ],
  "Novotech SSEISO": [
    "de 700 a 2,000 m²",
    "de 2,001 a 5,000 m²",
    "de 5,000 a 10,000m²",
  ],
};

export const downPayments = {
  "Hacienda Vista Juriquilla": [
    "de $23,200 a $46,400",
    "de $46,400 a $92,800",
    "Más de $92,800",
  ],
  "Novotech SSEISO": [
    "de $210,000 a $600,000",
    "de $601,000 a $1,500,000",
    "Más de $1,501,000",
  ],
};

export const monthlyPayments = {
  "Hacienda Vista Juriquilla": [
    "de $3,051 a $6,927",
    "de $6,927 a $13,854",
    "Más de $13,854",
  ],
  "Novotech SSEISO": [
    "de $29,000 a $88,000",
    "de $89,000 a $221,000",
    "Más de $221,000",
  ],
};
